<template>
	<div>
		<div class="row">
			<div class="col-xs-12 col-md-3 form-group">
				<label>Número de Ordem:</label>
				<input type="text" v-model="form.numero_ordem" class="form-control input-sm" />
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label>Identidade:</label>
				<input type="text" v-model="form.identidade" class="form-control input-sm" />
			</div>

			<div class="col-xs-12 col-md-3 form-group" v-if="exibeMatricula">
				<label>{{ labelMatricula }}:</label>
				<input type="text" v-model="form.matricula" class="form-control input-sm" />
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label>{{ _traducao('global', 'nomeTratamento') }}:</label>
				<input type="text" v-model="form.nome_guerra" class="form-control input-sm" />
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label>{{ _traducao('menuAGnovoUsuario', 'menuAGposto') }}:</label>
				<select v-model="form.id_posto_graduacao" class="form-control input-sm">
					<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
					<option v-for="(item, idx) in postos" :value="item.id" :key="idx">{{ item.descricao }}</option>
				</select>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		postos: {
			type: Array
		},

		cargos: {
			type: Array
		},
		menu: {
			type: Boolean
		}
	},
	data() {
		return {
			exibeMatricula: false,
			labelMatricula: '',
			form: {
				numero_ordem: '',
				identidade: '',
				matricula: '',
				nome_guerra: '',
				posto_graduacao: ''
			}
		}
	},

	created() {
		this._getParametro(25).then((habilitado) => {
			if (habilitado != null && Boolean(Number(habilitado)))
				this._getParametro(26).then((nome) => {
					this.labelMatricula = nome
					this.exibeMatricula = true
				})
			else this.exibeMatricula = false
		})
	},

	methods: {
		editar(item) {
			this.form.numero_ordem = item.numero_ordem
			this.form.identidade = item.identidade
			this.form.matricula = item.matricula
			this.form.nome_guerra = item.nome_guerra
			this.form.id_posto_graduacao = item.id_posto_graduacao
		},
		limpaForm() {
			this.form = {
				masp: '',
				data_nascimento: '',
				cargo: '',
				nome_guerra: '',
				posto_graduacao: ''
			}
		},

		getDados() {
			this.$emit('dados-adicionais', this.form)
		}
	}
}
</script>